"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NETWORKS_APAC = exports.NETWORKS_PROD = exports.NETWORKS_SANDBOX = exports.NETWORKS_RC = exports.NETWORKS_DEV = void 0;
const network_utils_1 = require("./network-utils");
function aptosExplorerUrlBuilder(explorerUrlTemplateString, operation, value) {
    if (operation === network_utils_1.OperationTypes.TX_HASH) {
        return explorerUrlTemplateString
            .replace('{operation}', 'txn')
            .replace('{value}', value);
    }
    else {
        return explorerUrlTemplateString
            .replace('{operation}', 'account')
            .replace('{value}', value);
    }
}
exports.NETWORKS_DEV = [
    {
        id: 'algorand',
        name: 'ALGORAND - Testnet',
        explorerUrlTemplateString: 'https://testnet.algoexplorer.io/{operation}/{value}',
    },
    {
        id: 'avalanche',
        name: 'AVALANCHE - Testnet',
        explorerUrlTemplateString: 'https://testnet.snowtrace.io/{operation}/{value}',
    },
    {
        id: 'polygon',
        name: 'POLYGON - Testnet',
        explorerUrlTemplateString: 'https://www.oklink.com/amoy/{operation}/{value}',
    },
    {
        id: 'ethereum-sepolia',
        name: 'SEPOLIA ETH - Testnet',
        explorerUrlTemplateString: 'https://sepolia.etherscan.io/{operation}/{value}',
    },
    {
        id: 'ganache',
        name: 'GANACHE - Private Testnet',
        explorerUrlTemplateString: null,
    },
    {
        id: 'xdc',
        name: 'XDC',
        explorerUrlTemplateString: 'https://explorer.apothem.network/{operation}/{value}',
    },
    {
        id: 'base',
        name: 'BASE',
        explorerUrlTemplateString: 'https://sepolia.basescan.org/{operation}/{value}',
    },
    {
        id: 'arbitrum',
        name: 'Arbitrum One',
        explorerUrlTemplateString: 'https://sepolia.arbiscan.io/{operation}/{value}',
    },
    {
        id: 'optimism',
        name: 'Optimism',
        explorerUrlTemplateString: 'https://sepolia-optimism.etherscan.io/{operation}/{value}',
    },
    {
        id: 'aptos',
        name: 'APTOS - Testnet',
        explorerUrlTemplateString: 'https://explorer.aptoslabs.com/{operation}/{value}?network=testnet',
        explorerUrlBuilder: aptosExplorerUrlBuilder,
    },
];
exports.NETWORKS_RC = [
    {
        id: 'algorand',
        name: 'ALGORAND - Testnet',
        explorerUrlTemplateString: 'https://testnet.algoexplorer.io/{operation}/{value}',
    },
    {
        id: 'avalanche',
        name: 'AVALANCHE - Testnet',
        explorerUrlTemplateString: 'https://testnet.snowtrace.io/{operation}/{value}',
    },
    {
        id: 'polygon',
        name: 'POLYGON - Testnet',
        explorerUrlTemplateString: 'https://www.oklink.com/amoy/{operation}/{value}',
    },
    {
        id: 'ethereum-sepolia',
        name: 'SEPOLIA ETH - Testnet',
        explorerUrlTemplateString: 'https://sepolia.etherscan.io/{operation}/{value}',
    },
    {
        id: 'xdc',
        name: 'XDC',
        explorerUrlTemplateString: 'https://explorer.apothem.network/{operation}/{value}',
    },
    {
        id: 'base',
        name: 'BASE',
        explorerUrlTemplateString: 'https://sepolia.basescan.org/{operation}/{value}',
    },
    {
        id: 'arbitrum',
        name: 'Arbitrum',
        explorerUrlTemplateString: 'https://sepolia.arbiscan.io/{operation}/{value}',
    },
    {
        id: 'optimism',
        name: 'Optimism',
        explorerUrlTemplateString: 'https://sepolia-optimism.etherscan.io/{operation}/{value}',
    },
    {
        id: 'aptos',
        name: 'APTOS - Testnet',
        explorerUrlTemplateString: 'https://explorer.aptoslabs.com/{operation}/{value}?network=testnet',
        explorerUrlBuilder: aptosExplorerUrlBuilder,
    },
];
exports.NETWORKS_SANDBOX = [
    {
        id: 'algorand',
        name: 'ALGORAND - Mainnet',
        explorerUrlTemplateString: 'https://algoexplorer.io/{operation}/{value}',
    },
    {
        id: 'algorand-testnet',
        name: 'ALGORAND - Testnet',
        explorerUrlTemplateString: 'https://testnet.algoexplorer.io/{operation}/{value}',
    },
    {
        id: 'quorum-ntt',
        name: 'QUORUM - NTT',
        explorerUrlTemplateString: null,
    },
    {
        id: 'avalanche',
        name: 'AVALANCHE - Testnet',
        explorerUrlTemplateString: 'https://testnet.snowtrace.io/{operation}/{value}',
    },
    {
        id: 'polygon',
        name: 'POLYGON - Testnet',
        explorerUrlTemplateString: 'https://mumbai.polygonscan.com/{operation}/{value}',
    },
    {
        id: 'quorum-sbi',
        name: 'BESU Kaleido - SBI',
        explorerUrlTemplateString: null,
    },
    {
        id: 'ethereum-sepolia',
        name: 'SEPOLIA ETH - Testnet',
        explorerUrlTemplateString: 'https://sepolia.etherscan.io/{operation}/{value}',
    },
    {
        id: 'xdc',
        name: 'XDC - Testnet',
        explorerUrlTemplateString: 'https://explorer.apothem.network/{operation}/{value}',
    },
    {
        id: 'base',
        name: 'BASE',
        explorerUrlTemplateString: 'https://sepolia.basescan.org/{operation}/{value}',
    },
    {
        id: 'ginco',
        name: 'Ginco Quorum - Testnet',
        explorerUrlTemplateString: null,
    },
    {
        id: 'oqi',
        name: 'Onyx Quorum - Testnet',
        explorerUrlTemplateString: null,
    },
    {
        id: 'arbitrum',
        name: 'Arbitrum',
        explorerUrlTemplateString: 'https://sepolia.arbiscan.io/{operation}/{value}',
    },
    {
        id: 'optimism',
        name: 'Optimism',
        explorerUrlTemplateString: 'https://sepolia-optimism.etherscan.io/{operation}/{value}',
    },
    {
        id: 'aptos',
        name: 'APTOS - Testnet',
        explorerUrlTemplateString: 'https://explorer.aptoslabs.com/{operation}/{value}?network=testnet',
        explorerUrlBuilder: aptosExplorerUrlBuilder,
    },
];
exports.NETWORKS_PROD = [
    {
        id: 'ethereum',
        name: 'ETHEREUM - Mainnet',
        explorerUrlTemplateString: 'https://etherscan.io/{operation}/{value}',
    },
    {
        id: 'algorand',
        name: 'ALGORAND - Mainnet',
        explorerUrlTemplateString: 'https://algoexplorer.io/{operation}/{value}',
    },
    {
        id: 'avalanche',
        name: 'AVALANCHE - Mainnet',
        explorerUrlTemplateString: 'https://avascan.info/blockchain/c/{operation}/{value}',
    },
    {
        id: 'polygon',
        name: 'POLYGON',
        explorerUrlTemplateString: 'https://polygonscan.com/{operation}/{value}',
    },
    {
        id: 'xdc',
        name: 'XDC',
        explorerUrlTemplateString: 'https://explorer.xinfin.network/{operation}/{value}',
    },
    {
        id: 'arbitrum',
        name: 'ARBITRUM',
        explorerUrlTemplateString: 'https://arbiscan.io/{operation}/{value}',
    },
    {
        id: 'aptos',
        name: 'APTOS - Mainnet',
        explorerUrlTemplateString: 'https://explorer.aptoslabs.com/{operation}/{value}?network=mainnet',
        explorerUrlBuilder: aptosExplorerUrlBuilder,
    },
];
exports.NETWORKS_APAC = [
    {
        id: 'ethereum',
        name: 'ETHEREUM - Mainnet',
        explorerUrlTemplateString: null,
    },
    {
        id: 'quorum',
        name: 'QUORUM - Production',
        explorerUrlTemplateString: null,
    },
    {
        id: 'quorum-ntt2',
        name: 'QUORUM - NTT2',
        explorerUrlTemplateString: null,
    },
    {
        id: 'quorum-sbi',
        name: 'BESU Kaleido - SBI',
        explorerUrlTemplateString: null,
    },
    {
        id: 'ginco',
        name: 'Ginco Quorum',
        explorerUrlTemplateString: null,
    },
];
//# sourceMappingURL=networks.js.map